import React, { useState } from "react";
import Banner from "../components/Banner";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    feedback: "",
    is_anonoymous: false,
  });

  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccessMsg("");
    setErrorMsg("");

    try {
      const response = await fetch(
        "https://api-discloseai.essolutions.ai/api/v1/organizations/contact-us",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to submit form");
      }

      setSuccessMsg("Thank you for contacting us. We’ll get back to you soon.");
      setFormData({
        name: "",
        email: "",
        phone: "",
        feedback: "",
        is_anonoymous: false,
      });
    } catch (error) {
      setErrorMsg("Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Banner title="Contact Us" subtitle="We’d love to hear from you" />

      <section className="py-5" id="form">
        <div className="container">
          <div className="row g-5">

            {/* LEFT INFO */}
            <div className="col-md-5">
              <h4 className="fw-bold mb-3">Get in Touch</h4>

              <p className="text-muted">
                Have a question, concern, or feedback?  
                Fill out the form and our team will respond as soon as possible.
              </p>
{/* 
              <hr />

              <h6>Email</h6>
              <p>support@discloseai.com</p>

              <h6>Phone</h6>
              <p>+91 98765 43210</p>

              <h6>Address</h6>
              <p>
                DiscloseAI Pvt Ltd <br />
                Bangalore, India
              </p> */}
            </div>

            {/* RIGHT FORM */}
            <div className="col-md-7">
              <div className="card shadow-sm border-0">
                <div className="card-body p-4">

                  <h4 className="fw-bold mb-4">Contact Form</h4>

                  {/* Alerts */}
                  {successMsg && (
                    <div className="alert alert-success">{successMsg}</div>
                  )}
                  {errorMsg && (
                    <div className="alert alert-danger">{errorMsg}</div>
                  )}

                  <form onSubmit={handleSubmit}>
                    <div className="row g-3">

                      <div className="col-md-6">
                        <label className="form-label">Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          disabled={formData.is_anonoymous}
                          required={!formData.is_anonoymous}
                        />
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">Email</label>
                        <input
                          type="email"
                          className="form-control"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          disabled={formData.is_anonoymous}
                          required={!formData.is_anonoymous}
                        />
                      </div>

                      <div className="col-md-6">
                        <label className="form-label">Phone</label>
                        <input
                          type="text"
                          className="form-control"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          disabled={formData.is_anonoymous}
                        />
                      </div>

                      <div className="col-12">
                        <label className="form-label">Message</label>
                        <textarea
                          className="form-control"
                          rows="4"
                          name="feedback"
                          value={formData.feedback}
                          onChange={handleChange}
                          required
                        ></textarea>
                      </div>

                      <div className="col-12">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="is_anonoymous"
                            checked={formData.is_anonoymous}
                            onChange={handleChange}
                          />
                          <label className="form-check-label">
                            Submit anonymously
                          </label>
                        </div>
                      </div>

                      <div className="col-12">
                        <button
                          type="submit"
                          className="btn btn-primary btn-lg w-100"
                          disabled={loading}
                        >
                          {loading ? "Submitting..." : "Submit"}
                        </button>
                      </div>

                    </div>
                  </form>

                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
}

export default Contact;
